/**
 * Pre-defined colors for collections
 * These colors are chosen to work well with dark themes
 */

export interface CollectionColor {
  name: string;
  value: string;
}

export const COLLECTION_COLORS: CollectionColor[] = [
  { name: 'Indigo', value: '#6366f1' },
  { name: 'Purple', value: '#a855f7' },
  { name: 'Pink', value: '#ec4899' },
  { name: 'Red', value: '#ef4444' },
  { name: 'Orange', value: '#f97316' },
  { name: 'Amber', value: '#f59e0b' },
  { name: 'Emerald', value: '#10b981' },
  { name: 'Cyan', value: '#06b6d4' },
];

/**
 * Get a random pre-defined color
 */
export function getRandomCollectionColor(): string {
  const randomIndex = Math.floor(Math.random() * COLLECTION_COLORS.length);
  return COLLECTION_COLORS[randomIndex].value;
}

/**
 * Get the name of a pre-defined color by its hex value
 * Returns 'Custom' if the color is not in the pre-defined list
 */
export function getCollectionColorName(hexValue: string): string {
  const color = COLLECTION_COLORS.find(
    (c) => c.value.toLowerCase() === hexValue.toLowerCase()
  );
  return color ? color.name : 'Custom';
}

/**
 * Check if a color is one of the pre-defined colors
 */
export function isPreDefinedColor(hexValue: string): boolean {
  return COLLECTION_COLORS.some(
    (c) => c.value.toLowerCase() === hexValue.toLowerCase()
  );
}
